import { cn } from "@/lib/utils";

/** A settings panel's recessed group, e.g. a column of setting rows. */
export const Well = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "rounded-lg border border-neutral-750 bg-neutral-800",
      className,
    )}
  >
    {children}
  </div>
);
